<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AlXFPc/tc-custom/9781504048965.jpg?1705552131037" alt="This image is the cover for the book Two Inspector Wexford Mysteries, The Inspector Wexford Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Two Inspector Wexford Mysteries, The Inspector Wexford Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>London’s Inspector Wexford has two cases to solve—a murdered wife and a missing husband—in this double dose of a “masterful series” (<i>Los Angeles Times</i>).</b><br/><br/> Now in one volume, two novels in “one of the best-written detective series in the genre’s history,” from a <i>New York Times–</i>bestselling and three-time Edgar Award–winning author (<i>The Washington Post</i>).<br/>  <br/><i>The Veiled One</i>: “Why on earth?” wonders London’s chief inspector Reginald Wexford when a sixtyish housewife is found garroted in a shopping mall garage, her body concealed under a velvet shroud. Before he can find the answer, he’s nearly killed himself—by a politically motivated car bombing targeting his activist daughter. With the inspector in the hospital, the case falls to his partner, Mike Burden. But when a strange mother and son are suspected, Burdon’s trail leads him down a very twisted road.<br/>  <br/><i>An Unkindness of Ravens</i>: When a neighbor’s husband vanishes, Chief Inspector Wexford suspects the cad most likely ran off with one of his girlfriends. However, there <i>are</i> a few nagging concerns, like the man’s suspicious letter of resignation and his abandoned car. And is it just a fluke that his disappearance coincides with a rash of stabbings—all straight through the heart, all with male victims? Behind the seemingly placid domesticity of Wexford’s Sussex neighbors, there’s a growing web of tangling secrets, double lives, and triple-crosses. An Edgar Award finalist, this is a “mystery of the highest order” (<i>The New Yorker</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth Rendell
      </h2>
      
      <p class="authorDescription body article"><p>Edgar Award&ndash;winning author Ruth Rendell (b. 1930) has written more than seventy books and sold more than twenty million copies worldwide. A fellow of the Royal Society of Literature (London), she is the recipient of the Grand Master Award from the Mystery Writers of America and a Lifetime Achievement Award from the Crime Writers&rsquo; Association. Rendell&rsquo;s award-winning novels include <i>A Demon in My View</i> (1976), <i>A Dark-Adapted Eye </i>(1987), and <i>King Solomon&rsquo;s Carpet </i>(1991). Her popular crime stories featuring Chief Inspector Reginald Wexford were adapted into a long-running British television series (1987&ndash;2000) starring George Baker.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1868b9f9